export const CONTACT = {
  phoneDisplay: "+39 329 959 1277",
  phoneHref: "tel:+393299591277",
  whatsappNumber: "393299591277",
  whatsappMessage:
    "Buongiorno Musica & Moda 5.0, vorrei informazioni per prenotare un artista, uno show o una produzione.",
  email: "musicamoda@libero.it",
  city: "Catanzaro — Tour nazionali",
};

export const whatsappLink = () =>
  `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent(CONTACT.whatsappMessage)}`;

export const IMAGES = {
  heroStage:
    "https://images.unsplash.com/photo-1657208431551-cbf415b8ef26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHxf&ixlib=rb-4.1.0&q=85",
  heroPerformer:
    "https://images.pexels.com/photos/36439651/pexels-photo-36439651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  singers: "/uploads/voce-solista.jpg",
  band: "/uploads/gruppo-fr-project.png",
  ottavanota: "/uploads/ottavanota-tour-2026.jpeg",
  dancers:
    "https://images.unsplash.com/photo-1503095396549-807759245b35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxkYW5jZXJzJTIwc3RhZ2UlMjBwZXJmb3JtYW5jZSUyMHNpbGhvdWV0dGUlMjBkcmFtYXRpY3xlbnwwfHx8fDE3OTI2OTAwMzV8MA&ixlib=rb-4.1.0&q=85",
  variety:
    "https://images.pexels.com/photos/20898292/pexels-photo-20898292.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  runway:
    "https://images.unsplash.com/photo-1788801389792-6ecedaf26dcd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxmYXNoaW9uJTIwcnVud2F5JTIwc2hvdyUyMG1vZGVscyUyMGRyYW1hdGljJTIwbGlnaHRpbmclMjBoYXV0ZSUyMGNvdXR1cmUlMjBwb3J0cmFpdCUyMGJhY2tzdGFnZXxlbnwwfHx8fDE3OTI2OTAxNzR8MA&ixlib=rb-4.1.0&q=85",
  couture:
    "https://images.unsplash.com/photo-1788800556084-3ea31ed5ad02?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxmYXNoaW9uJTIwcnVud2F5JTIwc2hvdyUyMG1vZGVscyUyMGRyYW1hdGljJTIwbGlnaHRpbmclMjBoYXV0ZSUyMGNvdXR1cmUlMjBwb3J0cmFpdCUyMGJhY2tzdGFnZXxlbnwwfHx8fDE3OTI2OTAxNzR8MA&ixlib=rb-4.1.0&q=85",
  modelPortrait:
    "https://images.pexels.com/photos/33281306/pexels-photo-33281306.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  backstage:
    "https://images.pexels.com/photos/18869915/pexels-photo-18869915.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cinema:
    "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxmaWxtJTIwY2FtZXJhJTIwbW92aWUlMjBwcm9kdWN0aW9uJTIwc2V0JTIwc3R1ZGlvfGVufDB8fHx8MTc5MjY5MDAzNXww&ixlib=rb-4.1.0&q=85",
  tv:
    "https://images.pexels.com/photos/29043652/pexels-photo-29043652.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  studio:
    "https://images.unsplash.com/photo-1642177437932-75d846ad48f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwyfHxtdXNpYyUyMHJlY29yZGluZyUyMHN0dWRpbyUyMHNvdW5kJTIwbWl4aW5nJTIwZGVza3xlbnwwfHx8fDE3OTI2OTAwMzV8MA&ixlib=rb-4.1.0&q=85",
  vinyl:
    "https://images.unsplash.com/photo-1603048588665-791ca8aea617?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAxODF8MHwxfHNlYXJjaHszfHx2aW55bCUyMHJlY29yZCUyMHBsYXllciUyMGRpc2NvZ3JhcGh5JTIwYXVkaW8lMjBzdHVkaW98ZW58MHx8fDE3OTI2OTAwNDB8MA&ixlib=rb-4.1.0&q=85",
};

export const MARQUEE_ITEMS = [
  "CANTO",
  "GRUPPI MUSICALI",
  "BALLO",
  "MODA & SFILATE",
  "SHOW VARIETÀ",
  "PRODUZIONI CINEMATOGRAFICHE",
  "PRODUZIONI TELEVISIVE",
  "PRODUZIONI DISCOGRAFICHE",
  "MANAGEMENT ARTISTICO",
];

export const ARTIST_CATEGORIES = [
  { id: "all", label: "Tutti" },
  { id: "canto", label: "Cantanti & Vocalist" },
  { id: "band", label: "Gruppi & Band Live" },
  { id: "ballo", label: "Ballerini & Corpi di Ballo" },
  { id: "moda", label: "Moda & Sfilate" },
  { id: "show", label: "Show & Variety" },
];

export const ARTISTS = [
  {
    id: "voci",
    category: "canto",
    name: "Voci & Solisti",
    role: "Francesco Mercurio cantautore",
    tag: "CANTO",
    image: IMAGES.singers,
    video: "/uploads/francesco-mercurio-live.mp4",
  },
  {
    id: "liveband",
    category: "band",
    name: "FR Project Music",
    role: "Francesco Mercurio & Rosanna Paonessa — duo live per eventi, tour e palchi",
    tag: "GRUPPI MUSICALI",
    image: IMAGES.band,
    video: "/uploads/fr-project-live.mp4",
  },
  {
    id: "ottavanota",
    category: "band",
    name: "Ottavanota",
    role: "Band al completo in Tour 2026 — voci, tastiere, chitarra, basso e batteria",
    tag: "GRUPPI MUSICALI",
    image: IMAGES.ottavanota,
    video: "/uploads/ottavanota-live.mp4",
  },
  {
    id: "corpidiballo",
    category: "ballo",
    name: "Corpi di Ballo",
    role: "Danza moderna, classica, hip-hop e latina",
    tag: "BALLO",
    image: IMAGES.dancers,
  },
  {
    id: "runway",
    category: "moda",
    name: "Sfilate & Defilé",
    role: "Produzione e regia di eventi moda",
    tag: "MODA & SFILATE",
    image: IMAGES.runway,
  },
  {
    id: "indossatrici",
    category: "moda",
    name: "Indossatrici & Fotomodelli",
    role: "Casting moda, editoriali e campagne",
    tag: "MODA & SFILATE",
    image: IMAGES.modelPortrait,
  },
  {
    id: "variety",
    category: "show",
    name: "Show di Ogni Genere",
    role: "Cabaret, varietà, illusionismo e performing art",
    tag: "SHOW VARIETÀ",
    image: IMAGES.variety,
  },
];

export const PRODUCTIONS = [
  {
    id: "cinema",
    code: "PROD.01",
    title: "Produzioni Cinematografiche",
    desc: "Dal set al grande schermo: cortometraggi, documentari e lungometraggi con troupe e regia proprie.",
    image: IMAGES.cinema,
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    id: "tv",
    code: "PROD.02",
    title: "Produzioni Televisive",
    desc: "Format TV, fiction e intrattenimento per emittenti nazionali e piattaforme streaming.",
    image: IMAGES.tv,
    span: "lg:col-span-5",
  },
  {
    id: "disco",
    code: "PROD.03",
    title: "Etichetta Discografica",
    desc: "Produzione, distribuzione e promozione di singoli, EP e album dei nostri artisti.",
    image: IMAGES.vinyl,
    span: "lg:col-span-5",
  },
  {
    id: "studio",
    code: "PROD.04",
    title: "Studio di Registrazione",
    desc: "Sala di incisione, mix e mastering con fonici e produttori residenti.",
    image: IMAGES.studio,
    span: "lg:col-span-7",
  },
];

export const STATS = [
  { value: "120+", label: "Artisti in roster" },
  { value: "85", label: "Produzioni realizzate" },
  { value: "300+", label: "Eventi e sfilate" },
  { value: "30+", label: "Anni di esperienza" },
];
